import React from "react"

import { mdiGoogleSpreadsheet } from '@mdi/js';
import Icon from '@mdi/react';

const DownloadData = () => {
  return (
    <>
      <div className="download-data">
        <div className="download-data-container">
          <a href="https://docs.google.com/spreadsheets/d/1v6197--MX5N_cOAdXcykxzToZgd0Fkr0ptV5luAp28U/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="button is-small is-primary is-family-sans-serif is-uppercase">
            <Icon path={mdiGoogleSpreadsheet} size={1} className="mr-1" />
            <span>View the Raw Data</span>
          </a>
        </div>
      </div>
    </>
  )
}

export default DownloadData
